import { NavLink, useNavigate, useOutletContext } from "react-router";
import { useEffect, useRef, useState } from "react";
import ResultCase from "../components/Result/ResultCase/ResultCase";
import Carousel from "../components/Result/Carousel/Carousel";
import Popin from "../components/Result/Popin/Popin";
import PageTitle from "../components/PageTitle/PageTitle";

function Result() {
    const { questions, answers, questionsValidated, setQuestionsValidated } = useOutletContext();

    // Hook pour la navigation
    let navigate = useNavigate();

    // On créé l'état pour la page affichée
    const [ resultView, setResultView ] = useState(null);

    // Si le nombre de réponse sauvegardées est différent du nombre de questions
    // alors on redirige vers le quiz
    if(questions.length !== Object.keys(answers).length) {
        navigate(`/quiz/`);
    }

    // Si on affiche la page de résultat
    // et que l'on n'a pas encore validée la dernière question
    // alors on la valide
    if(questionsValidated !== questions.length) {
        setQuestionsValidated(questionsValidated + 1);
    }

    // On met en place un écouteur afin d'afficher le résultat en fonction de la majorité
    useEffect(() => {
        // Fonction pour compter les occurrences des réponses
        const getMajorityAnswer = (answers) => {
            // Objet pour stocker le nombre d'occurrences
            const nbAnswerByType = Object.values(answers).reduce((acc, answer) => {
                acc[answer] = (acc[answer] || 0) + 1;
                return acc;
            }, {});

            // Trouver la réponse majoritaire
            return Object.keys(nbAnswerByType).reduce((a, b) => (nbAnswerByType[a] > nbAnswerByType[b] ? a : b), '');
        };

        // La majorité vient d'être décidé donc on met à jour l'état resultView
        setResultView(getMajorityAnswer(answers));
    }, [answers]);

    // Mise en place d'un élément en haut de page pouvant recevoir le focus pour la navigation clavier
    const focusRef = useRef(null);

    // On met en place un écouteur afin de revenir en haut de la page lorsque resultView change
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });

        // On positionne le focus en haut de page
        if(focusRef.current) {
            focusRef.current.focus();
        }
    }, [resultView]);

    // Création de la liste des boutons du footer
    let buttonsList = null;
    if(resultView === "politique") {
        buttonsList =
            <ul>
                <li>
                    <button className="button button--styless" onClick={() => setResultView("festive")}>Radio festive</button>
                </li>
                <li>
                    <button className="button button--styless" onClick={() => setResultView("intime")}>Radio intime</button>
                </li>
                <li>
                    <NavLink to={'/quiz/0'} className="link">Refaire le test</NavLink>
                </li>
            </ul>;
    } else if(resultView === 'intime') {
        buttonsList =
            <ul>
                <li>
                    <button className="button button--styless" onClick={() => setResultView("politique")}>Radio politique</button>
                </li>
                <li>
                    <button className="button button--styless" onClick={() => setResultView("festive")}>Radio festive</button>
                </li>
                <li>
                    <NavLink to={'/quiz/0'} className="link">Refaire le test</NavLink>
                </li>
            </ul>;
    } else if(resultView === 'festive') {
        buttonsList =
            <ul>
                <li>
                    <button className="button button--styless" onClick={() => setResultView("politique")}>Radio politique</button>
                </li>
                <li>
                    <button className="button button--styless" onClick={() => setResultView("intime")}>Radio intime</button>
                </li>
                <li>
                    <NavLink to={'/quiz/0'} className="link">Refaire le test</NavLink>
                </li>
            </ul>;
    }

    // On créé une référence pour la popin
    const popin = useRef(null);

    // On créé les états autour de la popin
    const [ isPopinOpen, setIsPopinOpen ] = useState(false);
    const [ viewInPopin, setViewInPopin ] = useState(0);

    return (
        <>
            <PageTitle title={`Si j'étais une radio... résultat`} />
            {resultView !== null &&
                <>
                    <div ref={focusRef} tabIndex="-1" className="a11y__focus-helper"></div>
                    <PageTitle title={`Si j'étais une radio... ${resultView}`} />
                    <main role="main" className="quiz__container quiz__container--result grid--container">
                        <Popin popinRef={popin} isPopinOpen={isPopinOpen} setIsPopinOpen={setIsPopinOpen} view={viewInPopin} />
                        <ResultCase type={resultView} />
                        <Carousel majority={resultView} popinRef={popin} setIsPopinOpen={setIsPopinOpen} setViewInPopin={setViewInPopin} />
                    </main>
                    <footer role="contentinfo" className="grid--container">
                        <h2>
                            explorez d&apos;autres<br />
                            profils radio
                        </h2>
                        {buttonsList !== null &&
                            buttonsList
                        }
                    </footer>
                </>
            }

        </>
    )
}

export default Result;
